import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

import "@mdi/font/css/materialdesignicons.css";
// import colors from "vuetify/lib/util/colors";

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: colors.indigo.accent4
        primary: '#4664FF'
      },
      dark: {}
    }
  },
  icons: {
    iconfont: "mdi"
  }
});
